import React from 'react'
import styles from './DetailsColumn.module.css'

export function DetailsColumn ({ children }) {
  return <div className={styles.root}>{children}</div>
}
